module.exports = __webpack_public_path__ + "img/vitran.250bb19b.jpg";